import { replace } from "ramda";
//used for normazling formatted numbers 
export const  normalizeNumber=(phone:any) => replace(/(\d{3})(\d{3})(\d{4})/, "$1$2$3",replace(/[^\d]/g,"",phone));
//used for formatting the numbers into phonenumber format
export const  formatPhoneNumber=(phone:any) => replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3",replace(/[^\d]/g,"",phone));


